import React from 'react';

import APIDocsCurl from 'common/developers/docs/api/APIDocsCurl';
import APIDocsMethod from 'common/developers/docs/api/APIDocsMethod';
import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

const APIDocsDeleteCategoryBlock = () => {
  return (
    <APIDocsBlock>
      <div>
        <div className="heading">Delete category</div>
        <div className="text">Deletes a category If the category does not have sub categories.</div>
        <APIDocsTable
          title="Arguments"
          rows={[
            {
              description: 'Your secret API key.',
              heading: 'apiKey',
              subheading: 'string',
            },
            {
              description: 'The unique identifier of the category.',
              heading: 'categoryID',
              subheading: 'string',
            },
          ]}
        />
        <div className="subheading">Returns</div>
        <div className="text">Returns "success" if the category was successfully deleted.</div>
      </div>
      <div>
        <div className="text">Endpoint</div>
        <Highlight lang="http">https://canny.io/api/v1/categories/delete</Highlight>
        <APIDocsMethod />
        <APIDocsCurl
          path="https://canny.io/api/v1/categories/delete"
          body={`\\
    -d apiKey=YOUR_API_KEY \\
    -d categoryID=553c3ef8b8cdcd1501ba2200"`}
        />
        <div className="text">Example Response</div>
        <Highlight lang="json">success</Highlight>
      </div>
    </APIDocsBlock>
  );
};

export default APIDocsDeleteCategoryBlock;
